import { useState, useRef } from 'react';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { IconButton, Stack } from '@mui/material';
import { Icon } from '@iconify/react';
import powerOffIcon from '@iconify/icons-bx/power-off';
import { useTranslation } from 'react-i18next';

export default function ModalUser(props) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const { t } = useTranslation();

  return (
    <div>
      <IconButton
        ref={ref}
        sx={{ borderRadius: '0', width: '100%', justifyContent: 'start', gap: 1, marginLeft: 1.3 }}
        onClick={() => {
          handleOpen();
        }}
      >
        <Icon icon={powerOffIcon} width={24} height={24} sx={{ marginRight: '10%', marginLeft: '5%' }} />
        <Typography sx={{ color: 'text.secondary' }} variant="body2">
          {props.statusUser === 1 ? t('user.deactivate') : t('user.activate')}
        </Typography>
      </IconButton>
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>
          {props.statusUser === 1 ? t('user.confirm-deactivation') : t('user.confirm-activation')}
        </DialogTitle>
        <DialogContent>
          <Stack sx={{ marginTop: '5% auto ', flexDirection: 'row', justifyContent: 'space-between' }}>
            <Button
              variant="contained"
              color={props.statusUser === 1 ? 'error' : 'success'}
              onClick={() => {
                props.activeUser(props.statusUser, props.id);
                handleClose();
              }}
            >
              {props.statusUser === 1 ? t('user.disabled') : t('user.activate')}
            </Button>
            <Button onClick={handleClose} variant="contained">
              {t('user.cancel')}
            </Button>
          </Stack>
        </DialogContent>
      </Dialog>
    </div>
  );
}
